import { MDBBtn, MDBChip, MDBIcon, MDBInput, MDBInputGroup, MDBModalFooter, MDBSelect, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { customSearch, useAutoFocusSearchAfterLoads } from '../../../components/CustomSearchUtil/CustomSearch';
const AddToUsers = forwardRef((props, ref) => {
    console.log("propes :" + JSON.stringify(props))
    const { t, i18n } = useTranslation();
    const [selectedRows, setSelectedRows] = useState([]);
    const [addUsers, setAddUsers] = useState([]);
    const [removeUsers, setRemoveUsers] = useState([]);
    const [updatesourcedel, setUpdateSourceDel] = useState(false);
    const [selecteddUsers, setSelecteddUsers] = useState([]);
    const [prevaddedUsers, setPrevAddedUsers] = useState([]);
    const [sourceUsers, setSourceUsers] = useState([]);
    const [removeddUsers, setRemoveddUsers] = useState([]);
    const [searchSourceQuery, setSearchSourceQuery] = useState('');
    const [searchDetinationQuery, setSearchDetinationQuery] = useState('');
    const [addUsersExtensions, setAddUsersExtensions] = useState(new Set());
    const [sourceRecords, setSourceRecords] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,true)

   const filteredData = customSearch(sourceUsers, searchSourceQuery, [ "name", "extension", "location_name" ]);
    const basicData = {
        columns: [
            { label: "Name", field: "name", sort: true },
            { label: "Extension", field: "extension" },
            { label: "location", field: "location_name" },
        ],
        rows: sourceUsers
    };

    const addUser = (selectedObj) => {
        const itemIdex = addUsers.findIndex((item) => item.extension === selectedObj.extension);
        if (itemIdex === -1) {
            const updatedUsers = [...addUsers, selectedObj];
            setAddUsers(updatedUsers);
            const addUsersextension = new Set(updatedUsers.map(item => item.extension));
            setAddUsersExtensions(addUsersextension);
        } else {
            const updateList = [...addUsers];
            updateList.splice(itemIdex, 1);
            setAddUsers(updateList);
            const addUsersextension = new Set(updateList.map(item => item.extension));
            setAddUsersExtensions(addUsersextension);
        }

        const newRemoveList = removeUsers.filter(item => item.extension !== selectedObj.extension);
        setRemoveUsers(newRemoveList);

    }

    const handleDelete = (removeObj) => {
        const updateAddList = addUsers.filter((item) => item.extension !== removeObj.extension);
        setAddUsers(updateAddList);
        const addUsersextension = new Set(updateAddList.map(item => item.extension));
        setAddUsersExtensions(addUsersextension);
    }

    function setSelectAll(e) {
        e.preventDefault();
        e.stopPropagation();
        // debugger;
        //  const filteredUsers = filterUsersByQuery(sourceUsers, searchSourceQuery);
        if (filteredData.length === 0) {
            return;
        }

        const addUserextension = new Set(addUsers.map(item => item.extension));
        const newAddUsers = filteredData.filter(item => !addUserextension.has(item.extension));
        const finalAddUsers = addUsers.concat(newAddUsers);
        setAddUsers(finalAddUsers);
        const finaladdUserextensions = new Set(finalAddUsers.map(item => item.extension));
        setAddUsersExtensions(finaladdUserextensions);
    }

    useEffect(() => {
        if (props.sourceUsers?.length > 0 && !updatesourcedel) {
            props.setIsloading(false);
            //alert(JSON.stringify(props.selectedUsers));
            setSelecteddUsers(props.selectedUsers);
            //alert(JSON.stringify(props.selectedUsers))
            if (props.selectedUsers.length > 0 && !props?.allowDuplicate) {
                const extensionsToFilter = new Set(props.selectedUsers.map(item => item.extension));
                const filteredSource = props.sourceUsers.filter(item => !extensionsToFilter.has(item.extension));
                setSourceUsers(filteredSource);
                setSourceRecords(filteredSource);
            } else {
                setSourceUsers(props.sourceUsers);
                setSourceRecords(props.sourceUsers);
            }

            setUpdateSourceDel(true);
            if (!dataLoaded) {
                setDataLoaded(true);
            }
        }
    }, [props, updatesourcedel]);
    function submitAddUsers(e) {
        if (props.module == "blfUsers") {
            props.onAdd(addUsers);
            return;
        }
        props.setUpdateUsers(addUsers);
        props.setIsAddedUsers(true);
        props.onClose();
    }
    const updateSelectedStateData = (selectedState) => {
        let filteredAgents = selectedState != 'Select-Country' ? sourceRecords.filter((row) => row.location?.toString() === selectedState.toString()) ?? [] : sourceRecords
        setSourceUsers(filteredAgents);
    }



    return (
        <>
            <div>
                {/* <div className="addAdminRole_Popup">

                    <MDBSelect className="w-100"
                        data={[
                            { text: "Select-Country", value: '-1' },
                            { text: "India", value: 'India' },
                            { text: "PAk", value: 'PAk' },
                            { text: "USA", value: 'USA' },
                            { text: "Four", value: 4 },
                            { text: "Five", value: 5 },
                            { text: "Six", value: 6 },
                            { text: "Seven", value: 7 },
                            { text: "Eight", value: 8 },
                        ]}
                        onSelect={(e) => updateSelectedStateData(e.target.value)}
                    />

                </div> */}
                <div className="pt-3">
                    {(selecteddUsers.length > 0 || addUsers.length > 0) && (
                    <MDBInputGroup className='mb-3' textAfter={<MDBIcon fas icon='search' />}>
                        <input className='form-control' type='text' placeholder='Search'
                            value={searchDetinationQuery}
                            onChange={(e) => setSearchDetinationQuery(e.target.value)}
                        />
                    </MDBInputGroup>
                    )}
                    <div className="form-group row">
                        <div className="col-12">
                            <div className="form-outlines phoneNumberheight p-0">
                                <div className="chips chips-placeholder align-items-center d-flex flex-wrap">
                                    {selecteddUsers && selecteddUsers.length > 0 || addUsers && addUsers.length > 0 ? <>
                                        {selecteddUsers && selecteddUsers.length > 0 && (
                                            customSearch(selecteddUsers, searchDetinationQuery, ["name", "extension"])
                                                .map((item) => (
                                                    <MDBChip
                                                        key={item.extension} className="m-chip d-inline py-2 px-3">
                                                        {item.name}
                                                    </MDBChip>
                                                ))
                                        )}
                                        {addUsers && addUsers.length > 0 && (
                                           customSearch(addUsers, searchDetinationQuery, [ "name", "extension" ])
                                                .map((item) => (
                                                    <MDBChip
                                                        onDelete={() => handleDelete(item)} className="m-chip d-inline py-2 px-3"
                                                        key={item.extension} closeIcon size="sm">
                                                        {item.name}
                                                    </MDBChip>
                                                ))
                                        )}
                                    </> : <>
                                        <p className='m-0 text-secondary text-center'>
                                            The selected Users will appear in this section
                                        </p>
                                    </>}
                                </div>
                            </div>
                            <label className="my-3 text-primary cursor-pointer link" onClick={(e) => setSelectAll(e)}>
                                {t("selectAll")}
                            </label>

                            {addUsers ?
                                <MDBInputGroup className='mb-3' textAfter={<MDBIcon fas icon='search' />}>
                                    <input className='form-control' type='text' ref={searchRef} placeholder='Search'
                                        value={searchSourceQuery}
                                        onChange={(e) => setSearchSourceQuery(e.target.value)} />
                                </MDBInputGroup>
                                :

                                <div className="d-flex">

                                    <MDBSelect className='me-2'
                                        data={[
                                            { text: 'User', value: 1 },
                                            { text: 'Group', value: 2 },
                                            { text: 'Everyone', value: 3 },
                                        ]}
                                    />
                                    <div className="position-relative w-100">
                                        <MDBInput placeholder='Search' />
                                        <div className="iconHolder">
                                            <MDBIcon fas icon="search" />
                                        </div>
                                    </div>
                                </div>

                            }

                            <div className="addAdminTable_height">
                                <MDBTable
                                    hover
                                    itemScope
                                    small
                                    fix
                                >
                                    <MDBTableHead className="table-header-sticky">
                                        <tr >
                                            {basicData?.columns &&
                                                basicData.columns.map((col) => {
                                                    return (
                                                        <th scope='col' key={col.field}>
                                                            {col.label}
                                                        </th>
                                                    );
                                                })}
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody className='addToUserTable'>
                                        {/* {sourceUsers?.length > 0 &&
                                          // HIGHLIGHT: use reusable filter here also
                                            filterUsersByQuery(sourceUsers, searchSourceQuery) */}
                                            {filteredData.length > 0 && 
                                                filteredData.map((row) => (
                                                    <tr

                                                        className={addUsersExtensions?.has(row.extension) ? 'addUsers-select' : ''}
                                                        onClick={() => addUser(row)}>

                                                        {basicData?.columns.map((column) => (

                                                            <td className="cursor-pointer">
                                                                {row[column.field]}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}
                                        {filteredData == undefined || filteredData?.length == 0 &&
                                            <td colSpan={3} className="text-center">
                                                No records found
                                            </td>
                                        }
                                    </MDBTableBody>
                                </MDBTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                    {t("close")}
                </MDBBtn>
                <MDBBtn onClick={(e) => submitAddUsers(e)}>{t("save")}</MDBBtn>
            </MDBModalFooter> */}
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => submitAddUsers(e)}>
                    {t("add")}</button>
            </div>

        </>
    )
});

export default AddToUsers;